import React from "react";
import { BsCheckCircleFill } from "react-icons/bs";
import "./auth.css";

const AuthLayout = ({ title, subtitle, side, children }) => {
  return (
    <div className="auth-page">
      {side && (
        <aside className="auth-side">
          <div className="auth-side-inner">
            <img
              src="/images/FindxStorage3.png"
              alt="FindxStorage"
              style={{ height: "44px", width: "auto", marginBottom: "2.5rem", alignSelf: "flex-start" }}
            />
            <h2 className="a-font auth-side-heading">{side.heading}</h2>
            <ul className="auth-side-points a-font">
              {side.points.map((point) => (
                <li key={point}>
                  <BsCheckCircleFill className="auth-side-check" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
            {side.footer && <div className="auth-side-footer a-font">{side.footer}</div>}
          </div>
        </aside>
      )}

      <div className="auth-main">
        <div className="auth-box">
          <div className="text-center mb-3">
            <img
              src="/images/blufindx.png"
              alt="FindxStorage"
              className="d-lg-none"
              style={{ width: "75px", height: "39px", marginBottom: "12px" }}
            />
            <h1
              className="a-font"
              style={{ fontSize: "28px", fontWeight: 700, color: "#202224", marginBottom: "4px" }}
            >
              {title}
            </h1>
            <p className="a-font" style={{ fontSize: "15px", color: "#5c5f66", marginBottom: 0 }}>
              {subtitle}
            </p>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
